import { render, staticRenderFns } from "./CopyrightBanner.vue?vue&type=template&id=595a9f87&scoped=true&"
import script from "./CopyrightBanner.vue?vue&type=script&lang=js&"
export * from "./CopyrightBanner.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightBanner.vue?vue&type=style&index=0&id=595a9f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595a9f87",
  null
  
)

export default component.exports